import React from "react";
import { motion } from "framer-motion";
import { processSteps } from "../data/mock";
import { Reveal, ChapterTag, EASE } from "../lib/motion";

export const ProcessSection = () => {
  return (
    <section id="process" data-testid="process-section" className="py-24 sm:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="06" label="How Teqie works" />
          <h2 className="mt-6 font-display font-semibold text-stone-900 tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl leading-[1.1]">
            {processSteps.heading}
          </h2>
        </Reveal>

        <div className="mt-16 space-y-0">
          {processSteps.steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -32 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.05, ease: EASE }}
              className="group grid grid-cols-[auto_1fr] sm:grid-cols-[120px_1fr_1.2fr] gap-x-6 sm:gap-x-12 gap-y-2 py-10 border-t border-stone-300/70 last:border-b items-start hover:bg-white/60 transition-colors duration-300 rounded-lg px-2 sm:px-4 -mx-2 sm:-mx-4"
              data-testid={`process-step-${i}`}
            >
              <span className="font-display font-normal text-5xl sm:text-7xl text-brand-600/25 group-hover:text-brand-600/60 transition-colors duration-500 leading-none">
                {step.step}
              </span>
              <div>
                <h3 className="font-display font-semibold text-2xl sm:text-3xl text-stone-900">{step.title}</h3>
                <p className="mt-2 font-display  text-brand-700 text-base md:text-lg leading-snug">{step.tagline}</p>
              </div>
              <p className="col-span-2 sm:col-span-1 text-stone-600 leading-relaxed text-sm sm:text-base sm:pt-2">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
